import { motion } from 'framer-motion';
import {
  Banknote,
  Briefcase,
  Building,
  Factory,
  GraduationCap,
  PartyPopper,
  ShoppingBag,
  Store,
} from 'lucide-react';
import { Section, SectionTitle } from '@/components/landing/Section';

const CATEGORIES = [
  { icon: Banknote, label: 'Empresas Financieras' },
  { icon: ShoppingBag, label: 'Centros Comerciales' },
  { icon: Building, label: 'Condominios' },
  { icon: Factory, label: 'Industrias' },
  { icon: GraduationCap, label: 'Instituciones Educativas' },
  { icon: Briefcase, label: 'Corporativos' },
  { icon: PartyPopper, label: 'Eventos' },
  { icon: Store, label: 'Comercios' },
];

export function Clients() {
  return (
    <Section id="clients">
      <SectionTitle subtitle="Protegemos a organizaciones de todos los sectores en el Paraguay.">
        Clientes
      </SectionTitle>
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
        {CATEGORIES.map((c, i) => {
          const Icon = c.icon;
          return (
            <motion.div
              key={c.label}
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: '-40px' }}
              transition={{ duration: 0.3, delay: i * 0.05 }}
              whileHover={{ y: -4 }}
              className="flex flex-col items-center gap-2 rounded-2xl border border-white/[0.06] bg-white/[0.02] p-6 text-center transition-colors hover:bg-white/[0.04]"
            >
              <Icon className="h-7 w-7 text-primary" strokeWidth={1.5} aria-hidden />
              <span className="text-sm font-medium text-slate-300">{c.label}</span>
            </motion.div>
          );
        })}
      </div>
    </Section>
  );
}
